export enum SegmentType {
  Text,
  URL,
}

export type TextAndUrlSegments = {
  segmentType: SegmentType;
  content: string;
}[];

export function parseTextAndUrlSegments(text: string): TextAndUrlSegments {
  const urlRegex =
    /((?:http:\/\/|https:\/\/|sms:|tel:|mailto:)[^\s]+[^\s.?!])/g;
  const segments = text.split(urlRegex);

  return segments
    .map((segment, index) => {
      if (index % 2 === 0) {
        return {
          segmentType: SegmentType.Text,
          content: segment,
        };
      } else {
        return {
          segmentType: SegmentType.URL,
          content: segment,
        };
      }
    })
    .filter(segment => segment.content !== "");
}

// Guaranteed to return unique URLs in the order they first appear in the text
export function uniqUrlsFromSegments(extraction: TextAndUrlSegments): string[] {
  return Array.from(
    new Set(
      extraction
        .filter(segment => segment.segmentType === SegmentType.URL)
        .map(segment => segment.content)
    )
  );
}

export function replaceURLs<T>(
  extraction: TextAndUrlSegments,
  replacement: (url: string) => T
): (T | string)[] {
  return extraction.map(segment => {
    if (segment.segmentType === SegmentType.URL) {
      return replacement(segment.content);
    } else {
      return segment.content;
    }
  });
}
